<template>
  <div>
    <div v-if="type=='vehicle'">
        {{ $t('user_messages.destination_type.'+type) }}
        <VehicleBrief :label="id" sizeClass="h6" :showLink="false" :showIndividualCall="true" :showGps="false"/>
    </div>
    <div v-else>
        {{ $t('user_messages.destination_type.'+type) }} - {{ direction }} -- {{ id }}
    </div>
  </div>
</template>

<script>
import VehicleBrief from '@/components/Realtime/VehicleBrief'

export default {
    components: { VehicleBrief },
    props: {
        direction: { type: String, default: "in" },
        type: { type:String, default:""},
        id: { type: String, default: "" }
    }
}
</script>

<style>

</style>